export interface RouteInfo {
  title: string;
  icon: string;
  module: string;
}

const RouteMap: { [key: string]: RouteInfo } = {
  // Home
  '/daf/home/inicio': {
    title: 'Home / Início',
    icon: 'home',
    module: 'Home',
  },
  '/daf/home/alertas': {
    title: 'Home / Alertas',
    icon: 'home',
    module: 'Home',
  },
  '/daf/home/numeros': {
    title: 'Home / Alertas',
    icon: 'home',
    module: 'Home',
  },

  ////////////////// Demandas de Informações
  '/daf/home/demandasinformacoes': {
    title: 'Home / Demandas de Informações',
    icon: 'home',
    module: 'Home',
  },
  '/daf/home/demandasinformacoes/ficha/dadosgerais': {
    title: 'Home / Demandas de Informações / Demanda',
    icon: 'home',
    module: 'Home',
  },
  '/daf/home/demandasinformacoes/ficha/:id/dadosgerais': {
    title: 'Home / Demandas de Informações / Demanda',
    icon: 'home',
    module: 'Home',
  },

  ////////////////// Glossário
  '/daf/home/glossario': {
    title: 'Home / Glossário',
    icon: 'home',
    module: 'Home',
  },
  '/daf/home/glossario/ficha/dadosgerais': {
    title: 'Home / Glossário / Termo',
    icon: 'home',
    module: 'Home',
  },
  '/daf/home/glossario/ficha/:id/dadosgerais': {
    title: 'Home / Glossário / Termo',
    icon: 'home',
    module: 'Home',
  },

  // Meus Dados
  '/daf/meusdados/usuario': {
    title: 'Meus Dados / Usuário',
    icon: 'person',
    module: 'Meus Dados',
  },
  '/daf/meusdados/logs': {
    title: 'Meus Dados / Meus Logs',
    icon: 'person',
    module: 'Meus Dados',
  },
  '/daf/meusdados/acessos': {
    title: 'Meus Dados / Meus Acessos',
    icon: 'person',
    module: 'Meus Dados',
  },
  '/daf/meusdados/relatorios': {
    title: 'Meus Dados / Relatórios Gerados',
    icon: 'description',
    module: 'Meus Relatórios',
  },

  // Adm
  '/daf/adm/usuarios': {
    title: 'Admin / Lista de Usuários',
    icon: 'settings',
    module: 'Admin',
  },

  '/daf/adm/usuarios/ficha/:id/dadosgerais': {
    title: 'Admin / Lista de Usuários / Dados do Usuário',
    icon: 'settings',
    module: 'Admin',
  },
  '/daf/adm/logs': {
    title: 'Admin / Logs',
    icon: 'settings',
    module: 'Admin',
  },
  '/daf/adm/acessos': {
    title: 'Admin / Acessos',
    icon: 'settings',
    module: 'Admin',
  },

  '/daf/adm/relatorios': {
    title: 'Admin / Relatórios Gerados',
    icon: 'settings',
    module: 'Relatórios Gerados',
  },
  '/daf/adm/fluxosproaqs': {
    title: 'Admin / Fluxos de Processos Aquisitivos',
    icon: 'settings',
    module: 'Fluxos de Processos Aquisitivos',
  },

  '/daf/adm/fluxosproaqs/fluxoproaq/ficha/dadosgerais': {
    title:
      'Admin / Fluxos de Processos Aquisitivos / Fluxo de Processos Aquisitivos',
    icon: 'settings',
    module: 'Fluxos de Proaq',
  },

  '/daf/adm/fluxosproaqs/fluxoproaq/ficha/:id/dadosgerais': {
    title:
      'Admin / Fluxos de Processos Aquisitivos / Fluxo de Processos Aquisitivos',
    icon: 'settings',
    module: 'Fluxos de Proaq',
  },

  '/daf/adm/fluxosproaqs/fluxoproaq/ficha/vinculos': {
    title:
      'Admin / Fluxos de Processos Aquisitivos / Fluxo de Processos Aquisitivos',
    icon: 'settings',
    module: 'Fluxos de Proaq',
  },

  '/daf/adm/fluxosproaqs/fluxoproaq/ficha/:id/vinculos': {
    title:
      'Admin / Fluxos de Processos Aquisitivos / Fluxo de Processos Aquisitivos',
    icon: 'settings',
    module: 'Fluxos de Proaq',
  },
  ////////////////// Domínios
  '/daf/adm/dominios': {
    title: 'Admin / Domínios',
    icon: 'settings',
    module: 'Domínios',
  },
  '/daf/adm/dominios/dominio/dadosgerais': {
    title: 'Admin / Domínios / Domínio',
    icon: 'settings',
    module: 'Domínios',
  },

  '/daf/adm/dominios/dominio/:id/dadosgerais': {
    title: 'Admin / Domínios / Domínio',
    icon: 'settings',
    module: 'Domínios',
  },
  ////////////////// Cores
  '/daf/adm/cores': {
    title: 'Admin / Cores',
    icon: 'settings',
    module: 'Cores',
  },
  '/daf/adm/cores/cor/dadosgerais': {
    title: 'Admin / Cores / Cor',
    icon: 'settings',
    module: 'Cores',
  },

  '/daf/adm/cores/cor/:id/dadosgerais': {
    title: 'Admin / Cores / Cor',
    icon: 'settings',
    module: 'Cores',
  },

  ////////////////// Setores DAF
  '/daf/adm/setores': {
    title: 'Admin / Setores DAF',
    icon: 'settings',
    module: 'Setores DAF',
  },
  '/daf/adm/setores/setor/dadosgerais': {
    title: 'Admin / Setores DAF / Setor',
    icon: 'settings',
    module: 'Setores DAF',
  },

  '/daf/adm/setores/setor/:id/dadosgerais': {
    title: 'Admin / Setores DAF / Setor',
    icon: 'settings',
    module: 'Setores DAF',
  },

  ////////////////// Módulos Sisaf
  '/daf/adm/modulossiaf': {
    title: 'Admin / Módulos Sisaf',
    icon: 'settings',
    module: 'Módulos Sisaf',
  },
  '/daf/adm/modulossiaf/modulo/dadosgerais': {
    title: 'Admin / Módulos Sisaf / Módulo',
    icon: 'settings',
    module: 'Módulos Sisaf',
  },
  '/daf/adm/modulossiaf/modulo/:id/dadosgerais': {
    title: 'Admin / Módulos Sisaf / Módulo',
    icon: 'settings',
    module: 'Módulos Sisaf',
  },

  ////////////////// Informes
  '/daf/adm/informes': {
    title: 'Admin / Informes',
    icon: 'settings',
    module: 'Admin',
  },
  '/daf/adm/informes/ficha/dadosgerais': {
    title: 'Admin / Informes / Informe',
    icon: 'settings',
    module: 'Admin',
  },
  '/daf/adm/informes/ficha/:id/dadosgerais': {
    title: 'Admin / Informes / Informe',
    icon: 'settings',
    module: 'Admin',
  },

  // Ajuda
  '/daf/maisopcoes/ajuda': {
    title: 'Mais Opções / Ajuda',
    icon: 'menu',
    module: 'Meus Dados',
  },

  // Mais Opções
  ////////////////// Alertas
  '/daf/maisopcoes/alertas': {
    title: 'Mais Opções / Alertas',
    icon: 'menu',
    module: 'Mais  Opções',
  },
  '/daf/maisopcoes/alertas/ficha/dadosgerais': {
    title: 'Mais Opções / Alertas / Alerta',
    icon: 'menu',
    module: 'Mais  Opções',
  },
  '/daf/maisopcoes/alertas/ficha/:id/dadosgerais': {
    title: 'Mais Opções / Alertas / Alerta',
    icon: 'menu',
    module: 'Mais  Opções',
  },

  ////////////////// Documentos
  '/daf/maisopcoes/documentos': {
    title: 'Mais Opções / Documentos',
    icon: 'menu',
    module: 'Mais  Opções',
  },
  '/daf/maisopcoes/documentos/ficha/dadosgerais': {
    title: 'Mais Opções / Documentos / Documento',
    icon: 'menu',
    module: 'Mais  Opções',
  },
  '/daf/maisopcoes/documentos/ficha/:id/dadosgerais': {
    title: 'Mais Opções / Documentos / Documento',
    icon: 'menu',
    module: 'Mais  Opções',
  },

  ////////////////// Tasks
  '/daf/maisopcoes/tasks': {
    title: 'Mais Opções / Tasks',
    icon: 'menu',
    module: 'Mais Opções',
  },
  '/daf/maisopcoes/tasks/ficha/dadosgerais': {
    title: 'Mais Opções / Tasks / Task',
    icon: 'menu',
    module: 'Mais  Opções',
  },
  '/daf/maisopcoes/tasks/ficha/:id/dadosgerais': {
    title: 'Mais Opções / Tasks / Task',
    icon: 'menu',
    module: 'Mais  Opções',
  },

  ////////////////// Tickets
  '/daf/maisopcoes/tickets': {
    title: 'Mais Opções / Tickets',
    icon: 'menu',
    module: 'Mais  Opções',
  },
  '/daf/maisopcoes/tickets/ficha/dadosgerais': {
    title: 'Mais Opções / Tickets / Ticket',
    icon: 'menu',
    module: 'Mais  Opções',
  },
  '/daf/maisopcoes/tickets/ficha/:id/dadosgerais': {
    title: 'Mais Opções / Tickets / Ticket',
    icon: 'menu',
    module: 'Mais  Opções',
  },

  ////////////////// Notas de Versão
  '/daf/maisopcoes/notas': {
    title: 'Mais Opções / Notas de Versão',
    icon: 'menu',
    module: 'Mais  Opções',
  },
  '/daf/maisopcoes/notas/ficha/dadosgerais': {
    title: 'Mais Opções / Notas / Nota',
    icon: 'menu',
    module: 'Mais  Opções',
  },
  '/daf/maisopcoes/notas/ficha/:id/dadosgerais': {
    title: 'Mais Opções / Notas / Nota',
    icon: 'menu',
    module: 'Mais  Opções',
  },

  // Produtos DAF
  ////////////////// Produtos
  '/daf/produtosdaf/produtos': {
    title: 'Produtos DAF / Produtos Farmacêuticos',
    icon: 'medication',
    module: 'Produtos DAF',
  },
  '/daf/produtosdaf/produtos/dadosgerais': {
    title: 'Produtos DAF / Produtos Farmacêuticos / Produto',
    icon: 'medication',
    module: 'Produtos DAF',
  },
  '/daf/produtosdaf/produtos/:id/dadosgerais': {
    title: 'Produtos DAF / Produtos Farmacêuticos / Produto Farmacêutico',
    icon: 'medication',
    module: 'Produtos DAF',
  },
  '/daf/produtosdaf/produtos/vinculos': {
    title: 'Produtos DAF / Produtos Farmacêuticos / Produto Farmacêutico',
    icon: 'medication',
    module: 'Produtos DAF',
  },
  '/daf/produtosdaf/produtos/:id/vinculos': {
    title: 'Produtos DAF / Produtos Farmacêuticos / Produto Farmacêutico',
    icon: 'medication',
    module: 'Produtos DAF',
  },

  ////////////////// Denominações Genéricas
  '/daf/produtosdaf/denominacoes': {
    title: 'Produtos DAF / Denominações Genéricas',
    icon: 'medication',
    module: 'Produtos DAF',
  },
  '/daf/produtosdaf/denominacoes/dadosgerais': {
    title: 'Produtos DAF / Denominações Genéricas / Denominação Genérica',
    icon: 'medication',
    module: 'Produtos DAF',
  },
  '/daf/produtosdaf/denominacoes/:id/dadosgerais': {
    title: 'Produtos DAF / Denominações Genéricas / Denominação Genérica',
    icon: 'medication',
    module: 'Produtos DAF',
  },
  '/daf/produtosdaf/denominacoes/vinculos': {
    title: 'Produtos DAF / Denominações Genéricas / Denominação Genérica',
    icon: 'medication',
    module: 'Produtos DAF',
  },
  '/daf/produtosdaf/denominacoes/:id/vinculos': {
    title: 'Produtos DAF / Denominações Genéricas / Denominação Genérica',
    icon: 'medication',
    module: 'Produtos DAF',
  },

  ////////////////// Kits de Produtos
  '/daf/produtosdaf/kits': {
    title: 'Produtos DAF / Kits de Produtos',
    icon: 'medication',
    module: 'Produtos DAF',
  },
  '/daf/produtosdaf/kits/dadosgerais': {
    title: 'Produtos DAF / Kits de Produtos / Kit de Produtos',
    icon: 'medication',
    module: 'Produtos DAF',
  },
  '/daf/produtosdaf/kits/:id/dadosgerais': {
    title: 'Produtos DAF / Kits de Produtos / Kit de Produtos',
    icon: 'medication',
    module: 'Produtos DAF',
  },
  '/daf/produtosdaf/kits/vinculos': {
    title: 'Produtos DAF / Kits de Produtos / Kit de Produtos',
    icon: 'medication',
    module: 'Produtos DAF',
  },
  '/daf/produtosdaf/kits/:id/vinculos': {
    title: 'Produtos DAF / Kits de Produtos / Kit de Produtos',
    icon: 'medication',
    module: 'Produtos DAF',
  },

  ////////////////// PDPs
  '/daf/produtosdaf/pdps': {
    title: 'Produtos DAF / PDPs',
    icon: 'medication',
    module: 'Produtos DAF',
  },
  '/daf/produtosdaf/pdps/ficha/dadosgerais': {
    title: 'Produtos DAF / PDPs / PDP',
    icon: 'medication',
    module: 'Produtos DAF',
  },
  '/daf/produtosdaf/pdps/ficha/:id/dadosgerais': {
    title: 'Produtos DAF / PDPs / PDP',
    icon: 'medication',
    module: 'Produtos DAF',
  },

  ////////////////// MedSUS - DAF
  '/daf/produtosdaf/medsus': {
    title: 'Produtos DAF / MedSUS / Gestão MedSUS',
    icon: 'medication',
    module: 'Produtos DAF',
  },
  '/daf/produtosdaf/medsus/dadosgerais': {
    title: 'Produtos DAF / MedSUS / Dados Gerais',
    icon: 'medication',
    module: 'Produtos DAF',
  },
  '/daf/produtosdaf/medsus/:id/dadosgerais': {
    title: 'Produtos DAF / MedSUS / Dados Gerais',
    icon: 'medication',
    module: 'Produtos DAF',
  },

  // SES
  '/daf/ses/ses': {
    title: 'Estabelecimentos de Saúde / Lista de Estabelecimentos',
    icon: 'medical_information',
    module: 'SES',
  },
  '/daf/ses/ses/ficha/dadosgerais': {
    title:
      'Estabelecimentos de Saúde / Lista de Estabelecimentos / Estabelecimento',
    icon: 'medical_information',
    module: 'SES',
  },
  '/daf/ses/ses/ficha/:id/dadosgerais': {
    title:
      'Estabelecimentos de Saúde / Lista de Estabelecimentos / Estabelecimento',
    icon: 'medical_information',
    module: 'SES',
  },
  '/daf/ses/ses/ficha/:id/usuarios': {
    title: 'Estabelecimentos de Saúde / Lista de Estabelecimentos / Usuários',
    icon: 'medical_information',
    module: 'SES',
  },
  '/daf/ses/ses/ficha/usuarios': {
    title: 'Estabelecimentos de Saúde / Lista de Estabelecimentos / Usuários',
    icon: 'medical_information',
    module: 'SES',
  },
  '/daf/ses/ses/ficha/:id/vinculo': {
    title: 'Estabelecimentos de Saúde / Lista de Estabelecimentos / Vínculo',
    icon: 'medical_information',
    module: 'SES',
  },

  // Fornecedores
  '/daf/fornecedores/fornecedores': {
    title: 'Fornecedores / Fornecedores DAF',
    icon: 'factory',
    module: 'Fornecedores',
  },

  '/daf/fornecedores/fornecedores/dadosgerais': {
    title: 'Fornecedores / Fornecedores DAF / Fornecedor',
    icon: 'factory',
    module: 'Fornecedores',
  },

  '/daf/fornecedores/fornecedores/:id/dadosgerais': {
    title: 'Fornecedores / Fornecedores DAF / Fornecedor',
    icon: 'factory',
    module: 'Fornecedores',
  },

  // Fornecedores - Representantes
  '/daf/fornecedores/fornecedores/:id/representantes': {
    title: 'Fornecedores / Fornecedores DAF / Fornecedor',
    icon: 'factory',
    module: 'Fornecedores',
  },

  // Fornecedores - Representantes PR
  '/daf/fornecedores/fornecedores/:id/pr': {
    title: 'Fornecedores / Fornecedores DAF / Fornecedor',
    icon: 'factory',
    module: 'Fornecedores',
  },

  // Fornecedores - Historico PR
  '/daf/fornecedores/fornecedores/:id/historicort': {
    title: 'Fornecedores / Fornecedores DAF / Fornecedor',
    icon: 'factory',
    module: 'Fornecedores',
  },

  // Fornecedores - Comunicações
  '/daf/fornecedores/fornecedores/:id/comunicacoes': {
    title: 'Fornecedores / Fornecedores DAF / Fornecedor',
    icon: 'factory',
    module: 'Fornecedores',
  },
  // Fornecedores - FAQ
  '/daf/fornecedores/faq': {
    title: 'Fornecedores / FAQ',
    icon: 'factory',
    module: 'Fornecedores',
  },

  '/daf/fornecedores/faq/ficha/dadosgerais': {
    title: 'Fornecedores / FAQ / FAQ',
    icon: 'factory',
    module: 'Fornecedores',
  },

  '/daf/fornecedores/faq/ficha/:id/dadosgerais': {
    title: 'Fornecedores / FAQ / FAQ',
    icon: 'factory',
    module: 'Fornecedores',
  },

  // Processos Jurídicos
  '/daf/procjur/processos': {
    title: 'Processos Jurídicos / Processos Jurídicos',
    icon: 'balance',
    module: 'Processos Jurídicos',
  },
  '/daf/procjur/processos/dadosgerais': {
    title: 'Processos Jurídicos / Processos Aquisitivos / Processo Aquisitivo',
    icon: 'balance',
    module: 'Processos Aquisitivos',
  },

  '/daf/procjur/processos/:id/dadosgerais': {
    title: 'Processos Jurídicos / Processos / Processo Jurídico',
    icon: 'balance',
    module: 'Processos Jurídicos',
  },
  '/daf/procjur/processos/manifestacaotecnica': {
    title: 'Processos Jurídicos / Processos Aquisitivos / Processo Aquisitivo',
    icon: 'balance',
    module: 'Processos Aquisitivos',
  },

  '/daf/procjur/processos/:id/manifestacaotecnica': {
    title: 'Processos Jurídicos / Processos / Processo Jurídico',
    icon: 'balance',
    module: 'Processos Jurídicos',
  },

  ////////////////// Listagem de Aquisições
  '/daf/proaq/aquisicoes': {
    title: 'Aquisições / Listagem de Aquisições',
    icon: 'edit_document',
    module: 'Aquisições',
  },

  // Processos Aquisitivos
  '/daf/proaq/processos': {
    title: 'Aquisições / Processos Licitatórios',
    icon: 'account_tree',
    module: 'Aquisições',
  },
  '/daf/proaq/processos/destaques': {
    title: 'Aquisições / Processos Licitatórios / Processo Aquisitivo',
    icon: 'account_tree',
    module: 'Aquisições',
  },
  '/daf/proaq/processos/:id/destaques': {
    title: 'Aquisições / Processos Licitatórios / Processo Aquisitivo',
    icon: 'account_tree',
    module: 'Aquisições',
  },
  '/daf/proaq/processos/dadosgerais': {
    title: 'Aquisições / Processos Licitatórios / Processo Aquisitivo',
    icon: 'account_tree',
    module: 'Aquisições',
  },

  '/daf/proaq/processos/:id/dadosgerais': {
    title: 'Aquisições / Processos Licitatórios / Processo Aquisitivo',
    icon: 'account_tree',
    module: 'Aquisições',
  },

  // Contratos
  ////////////////// ARPs
  '/daf/proaq/arps': {
    title: 'Aquisições / Atas de Registro de Preços',
    icon: 'account_tree',
    module: 'Aquisições',
  },
  '/daf/proaq/arps/dadosgerais': {
    title: 'Aquisições / ARPs / ARP',
    icon: 'account_tree',
    module: 'Aquisições',
  },

  '/daf/proaq/arps/:id/dadosgerais': {
    title: 'Aquisições / ARPs / ARP',
    icon: 'account_tree',
    module: 'Aquisições',
  },
  '/daf/proaq/arps/destaques': {
    title: 'Aquisições / ARPs / ARP',
    icon: 'account_tree',
    module: 'Aquisições',
  },

  '/daf/proaq/arps/:id/destaques': {
    title: 'Aquisições / ARPs / ARP',
    icon: 'account_tree',
    module: 'Aquisições',
  },

  ////////////////// Contratos
  '/daf/proaq/contratos': {
    title: 'Aquisições / Contratos',
    icon: 'account_tree',
    module: 'Aquisições',
  },
  '/daf/proaq/contratos/dadosgerais': {
    title: 'Aquisições / Contratos / Contrato',
    icon: 'account_tree',
    module: 'Aquisições',
  },

  '/daf/proaq/contratos/:id/dadosgerais': {
    title: 'Aquisições / Contratos / Contrato',
    icon: 'account_tree',
    module: 'Aquisições',
  },
  '/daf/proaq/contratos/destaques': {
    title: 'Aquisições / Contratos / Contrato',
    icon: 'account_tree',
    module: 'Aquisições',
  },

  '/daf/proaq/contratos/:id/destaques': {
    title: 'Aquisições / Contratos / Contrato',
    icon: 'account_tree',
    module: 'Aquisições',
  },
  '/daf/proaq/contratos/pautas': {
    title: 'Aquisições / Contratos / Contrato',
    icon: 'account_tree',
    module: 'Aquisições',
  },

  '/daf/proaq/contratos/:id/pautas': {
    title: 'Aquisições / Contratos / Contrato',
    icon: 'account_tree',
    module: 'Aquisições',
  },
  '/daf/proaq/contratos/entregas': {
    title: 'Aquisições / Contratos / Contrato',
    icon: 'account_tree',
    module: 'Aquisições',
  },

  '/daf/proaq/contratos/:id/entregas': {
    title: 'Aquisições / Contratos / Contrato',
    icon: 'account_tree',
    module: 'Aquisições',
  },

  ////////////////// TEDs
  '/daf/proaq/teds': {
    title: 'Aquisições / Termos de Execução Descentralizada',
    icon: 'account_tree',
    module: 'Aquisições',
  },
  '/daf/proaq/teds/dadosgerais': {
    title: 'Aquisições / TEDs / TED',
    icon: 'account_tree',
    module: 'Aquisições',
  },
  '/daf/proaq/teds/:id/dadosgerais': {
    title: 'Aquisições / TEDs / TED',
    icon: 'account_tree',
    module: 'Aquisições',
  },
  '/daf/proaq/teds/destaques': {
    title: 'Aquisições / TEDs / TED',
    icon: 'account_tree',
    module: 'Aquisições',
  },
  '/daf/proaq/teds/:id/destaques': {
    title: 'Aquisições / TEDs / TED',
    icon: 'account_tree',
    module: 'Aquisições',
  },
  '/daf/proaq/teds/pautas': {
    title: 'Aquisições / TEDs / TED',
    icon: 'account_tree',
    module: 'Aquisições',
  },

  '/daf/proaq/teds/:id/pautas': {
    title: 'Aquisições / TEDs / TED',
    icon: 'account_tree',
    module: 'Aquisições',
  },
  '/daf/proaq/teds/entregas': {
    title: 'Aquisições / TEDs / TED',
    icon: 'account_tree',
    module: 'Aquisições',
  },

  '/daf/proaq/teds/:id/entregas': {
    title: 'Aquisições / TEDs / TED',
    icon: 'account_tree',
    module: 'Aquisições',
  },

  ////////////////// ACTs
  '/daf/proaq/acts': {
    title: 'Aquisições / Acordos de Cooperação Técnica',
    icon: 'account_tree',
    module: 'Aquisições',
  },
  '/daf/proaq/acts/dadosgerais': {
    title: 'Aquisições / ACTs / ACT',
    icon: 'account_tree',
    module: 'Aquisições',
  },
  '/daf/proaq/acts/:id/dadosgerais': {
    title: 'Aquisições / ACTs / ACT',
    icon: 'account_tree',
    module: 'Aquisições',
  },
  '/daf/proaq/acts/destaques': {
    title: 'Aquisições / ACTs / ACT',
    icon: 'account_tree',
    module: 'Aquisições',
  },
  '/daf/proaq/acts/:id/destaques': {
    title: 'Aquisições / ACTs / ACT',
    icon: 'account_tree',
    module: 'Aquisições',
  },

  ////////////////// Organismos Internacionais
  '/daf/proaq/orginters': {
    title: 'Aquisições / Org. Internacionais',
    icon: 'account_tree',
    module: 'Aquisições',
  },
  '/daf/proaq/orginters/dadosgerais': {
    title: 'Aquisições / Org. Internacionais / Org. Internacional',
    icon: 'account_tree',
    module: 'Aquisições',
  },
  '/daf/proaq/orginters/:id/dadosgerais': {
    title: 'Aquisições / Org. Internacionais / Org. Internacional',
    icon: 'account_tree',
    module: 'Aquisições',
  },
  '/daf/proaq/orginters/destaques': {
    title: 'Aquisições / Org. Internacionais / Org. Internacional',
    icon: 'account_tree',
    module: 'Aquisições',
  },
  '/daf/proaq/orginters/:id/destaques': {
    title: 'Aquisições / Org. Internacionais / Org. Internacional',
    icon: 'account_tree',
    module: 'Aquisições',
  },

  ////////////////// Empenhos
  '/daf/proaq/empenhos': {
    title: 'Aquisições / Empenhos',
    icon: 'account_tree',
    module: 'Aquisições',
  },
  '/daf/proaq/empenhos/dadosgerais': {
    title: 'Aquisições / Empenhos / Empenho Orçamentário',
    icon: 'account_tree',
    module: 'Aquisições',
  },

  '/daf/proaq/empenhos/:id/dadosgerais': {
    title: 'Aquisições / Empenhos / Empenho Orçamentário',
    icon: 'account_tree',
    module: 'Aquisições',
  },
  '/daf/proaq/empenhos/destaques': {
    title: 'Aquisições / Empenhos / Empenho Orçamentário',
    icon: 'account_tree',
    module: 'Aquisições',
  },

  '/daf/proaq/empenhos/:id/destaques': {
    title: 'Aquisições / Empenhos / Empenho Orçamentário',
    icon: 'account_tree',
    module: 'Aquisições',
  },

  // Programação
  '/daf/programacao/programacoes': {
    title: 'Programação / Programações',
    icon: 'add_circle',
    module: 'Contratos',
  },

  ////////////////////////////////////////////////////// Logística
  ////////////////// Entregas Fornecedores
  '/daf/logistica/fornecedor': {
    title: 'Logística / Entregas Fornecedores',
    icon: 'local_shipping',
    module: 'Logística',
  },
  '/daf/logistica/fornecedor/dadosgerais': {
    title: 'Logística / Entregas Fornecedores / Entrega Fornecedor',
    icon: 'local_shipping',
    module: 'Logística',
  },
  '/daf/logistica/fornecedor/:id/dadosgerais': {
    title: 'Logística / Entregas Fornecedores / Entrega Fornecedor',
    icon: 'local_shipping',
    module: 'Logística',
  },
  '/daf/logistica/fornecedor/destaques': {
    title: 'Logística / Entregas Fornecedores / Entrega Fornecedor',
    icon: 'local_shipping',
    module: 'Logística',
  },
  '/daf/logistica/fornecedor/:id/destaques': {
    title: 'Logística / Entregas Fornecedores / Entrega Fornecedor',
    icon: 'local_shipping',
    module: 'Logística',
  },

  ////////////////// Fluxos Administrativos
  '/daf/adm/fluxos-adm': {
    title: 'Admin / Fluxos Administrativos',
    icon: 'settings',
    module: 'Fluxos Administrativos',
  },
  '/daf/adm/fluxos-adm/modelo/dadosgerais': {
    title: 'Admin / Fluxos Administrativos / Modelo',
    icon: 'settings',
    module: 'Fluxos Administrativos',
  },
  '/daf/adm/fluxos-adm/modelo/:id/dadosgerais': {
    title: 'Admin / Fluxos Administrativos / Modelo',
    icon: 'settings',
    module: 'Fluxos Administrativos',
  },

  // Página não encontrada
  '/': { title: 'Página não encontrada', icon: 'error', module: 'Erro!' }, // Rota genérica |* lidar com rotas não encontradas *|
};

export default RouteMap;
